/*export const countryConfigs = {
  id: {
    zh_name: '印尼', // 国家中文名
    lang: 'id-ID', // 语言
    i18n: 'in_ID', // i18n中对应的语言名
    default: true, // 是否为默认国家
    thous_separator: '.', // 千位分隔符
    decimal_point_separator: ',', // 小数分隔符
    decimalPlaces: 0, //小数位数
    symbolInAfter: false, //货币符号是否在后面
    cluster: 'sgp', // 所属集群
    fds_cluster: 'sgp', // fds 所属集群
    trackId: '1360', // 埋点id
    cookieIsOpen: false, // 是否打开cookie弹框
    supportWallet: true, // 是否支持开发「钱包 &&会员」模块功能
    routeFix: '/id', //路由中不同国家的前缀
    supportKCard: true, // 是否支持K-Card
    apm_cluster: 'sgp', // apm所属集群
    // 切换的语言信息
    region_lang_map: {
      value: 'Indonesia',
      icon: 'flag_id.png',
      langs: ['in'],
      children: {
        in: { value: 'Bahasa Indonesia' },
      },
    },
  },
  br: {
    zh_name: '巴西',
    lang: 'pt-BR',
    i18n: 'pt_BR',
    thous_separator: '.',
    decimal_point_separator: ',',
    decimalPlaces: 2,
    symbolInAfter: false,
    cluster: 'br',
    fds_cluster: 'us',
    trackId: '1076',
    cookieIsOpen: false,
    supportWallet: true,
    routeFix: '/br',
    apm_cluster: 'sgp',
    region_lang_map: {
      value: 'Brazil',
      icon: 'flag_br.png',
      langs: ['pt'],
      children: {
        pt: { value: 'Português' },
      },
    },
  },
  my: {
    zh_name: '马来西亚',
    lang: 'ms-MY',
    i18n: 'ms_MY',
    thous_separator: ',',
    decimal_point_separator: '.',
    decimalPlaces: 2,
    symbolInAfter: false,
    cluster: 'sgp',
    fds_cluster: 'sgp',
    trackId: '1458',
    cookieIsOpen: false,
    supportWallet: true,
    routeFix: '/my',
    apm_cluster: 'sgp',
    region_lang_map: {
      value: 'Malaysia',
      icon: 'flag_my.png',
      langs: ['ms'],
      children: {
        ms: { value: 'Bahasa Melayu' },
      },
    },
  },
  ru: {
    zh_name: '俄罗斯',
    lang: 'ru-RU',
    i18n: 'ru_RU',
    default: false,
    thous_separator: ' ',
    decimal_point_separator: ',',
    decimalPlaces: 2,
    symbolInAfter: true,
    cluster: 'ru',
    fds_cluster: 'ru',
    trackId: '1643',
    cookieIsOpen: false,
    supportWallet: true,
    routeFix: '/ru',
    apm_cluster: 'ru',
    region_lang_map: {
      value: 'Россия(Russia)',
      icon: 'flag_ru.png',
      langs: ['ru'],
      children: {
        ru: { value: 'Pусский' },
      },
    },
  },
  ph: {
    zh_name: '菲律宾',
    lang: 'en-PH',
    i18n: 'en_PH',
    thous_separator: ',',
    decimal_point_separator: '.',
    decimalPlaces: 2,
    symbolInAfter: false,
    cluster: 'sgp',
    fds_cluster: 'sgp',
    trackId: '1608',
    cookieIsOpen: false,
    supportWallet: true,
    routeFix: '/ph',
    apm_cluster: 'sgp',
    region_lang_map: {
      value: 'Philippines',
      icon: 'flag_ph.png',
      langs: ['en'],
      children: {
        en: { value: 'English' },
      },
    },
  },
  es: {
    zh_name: '西班牙',
    lang: 'es-ES',
    i18n: 'es_ES',
    thous_separator: '.',
    decimal_point_separator: ',',
    decimalPlaces: 2,
    symbolInAfter: true,
    cluster: 'de',
    fds_cluster: 'de',
    trackId: '1724',
    cookieIsOpen: true,
    supportWallet: true,
    routeFix: '/es',
    apm_cluster: 'de',
    region_lang_map: {
      value: 'Spain',
      icon: 'flag_es.png',
      langs: ['es'],
      children: {
        es: { value: 'Español (España)' },
      },
    },
  },
  de: {
    zh_name: '德国',
    lang: 'de-DE',
    i18n: 'de_DE',
    thous_separator: '.',
    decimal_point_separator: ',',
    decimalPlaces: 2,
    symbolInAfter: true,
    cluster: 'de',
    fds_cluster: 'de',
    trackId: '1276',
    cookieIsOpen: true,
    supportWallet: true,
    routeFix: '/de',
    apm_cluster: 'de',
    region_lang_map: {
      value: 'Germany',
      icon: 'flag_de.png',
      langs: ['de'],
      children: {
        de: { value: 'Deutsch' },
      },
    },
  },
  it: {
    zh_name: '意大利',
    lang: 'it-IT',
    i18n: 'it_IT',
    thous_separator: '.',
    decimal_point_separator: ',',
    decimalPlaces: 2,
    symbolInAfter: true,
    cluster: 'de',
    fds_cluster: 'de',
    trackId: '1380',
    cookieIsOpen: true,
    routeFix: '/it',
    apm_cluster: 'de',
    region_lang_map: {},
  },
  fr: {
    zh_name: '法国',
    lang: 'fr-FR',
    i18n: 'fr_FR',
    thous_separator: ' ',
    decimal_point_separator: ',',
    decimalPlaces: 2,
    symbolInAfter: true,
    cluster: 'de',
    fds_cluster: 'de',
    trackId: '1250',
    cookieIsOpen: true,
    supportWallet: true,
    routeFix: '/fr',
    apm_cluster: 'de',
    region_lang_map: {
      value: 'France',
      icon: 'flag_fr.png',
      langs: ['fr'],
      children: {
        fr: { value: 'Français' },
      },
    },
  },
  th: {
    zh_name: '泰国',
    lang: 'th-TH',
    i18n: 'th_TH',
    thous_separator: ',',
    decimal_point_separator: '.',
    decimalPlaces: 2,
    symbolInAfter: false,
    cluster: 'sgp',
    fds_cluster: 'sgp',
    trackId: '1764',
    cookieIsOpen: false,
    supportWallet: true,
    routeFix: '/th',
    apm_cluster: 'sgp',
    region_lang_map: {
      value: 'Thailand',
      icon: 'flag_th.png',
      langs: ['th'],
      children: {
        th: { value: 'ไทย' },
      },
    },
  },
  in: {
    zh_name: '印度',
    lang: ['en-IN', 'hi-IN'],
    i18n: 'en_IN',
    thous_separator: ',',
    decimal_point_separator: '.',
    decimalPlaces: 2,
    symbolInAfter: false,
    cluster: 'in',
    fds_cluster: 'sgp',
    trackId: '1356',
    cookieIsOpen: false,
    routeFix: '/in',
    apm_cluster: 'in',
    region_lang_map: {},
  },
  // uz: {
  //   zh_name: '乌兹别克斯坦',
  //   lang: 'uz-UZ',
  //   i18n: 'uz_UZ',
  //   thous_separator: ',',
  //   decimal_point_separator: '.',
  //   decimalPlaces: 2,
  //   symbolInAfter: true,
  //   cluster: 'sgp',
  //   fds_cluster: 'sgp',
  //   trackId: '1860',
  //   cookieIsOpen: false,
  //   supportWallet: true,
  //   routeFix: '/uz',
  //   apm_cluster: 'sgp',
  //   region_lang_map: {
  //     value: 'Uzbekistan',
  //     icon: 'flag_uz.png',
  //     langs: ['uz'],
  //     children: {
  //       uz: { value: "O'zbekcha" },
  //     },
  //   },
  // },
  tr: {
    zh_name: '土耳其',
    lang: 'tr-TR',
    i18n: 'tr_TR',
    thous_separator: '.',
    decimal_point_separator: ',',
    decimalPlaces: 2,
    symbolInAfter: true,
    cluster: 'sgp',
    fds_cluster: 'sgp',
    trackId: '1792',
    cookieIsOpen: false,
    supportWallet: false,
    routeFix: '/tr',
    apm_cluster: 'sgp',
    region_lang_map: {
      value: 'Türkiye',
      icon: 'flag_tr.png',
      langs: ['tr'],
      children: {
        tr: { value: 'Türkçe' },
      },
    },
  },
}*/

export const countryConfigs = {
  id: {
    zh_name: '印尼', // 国家中文名
    lang: 'id-ID', // 语言
    i18n: 'in_ID', // i18n中对应的语言名
    default: true, // 是否为默认国家
    thous_separator: '.', // 千位分隔符
    decimal_point_separator: ',', // 小数分隔符
    decimalPlaces: 0, //小数位数
    symbolInAfter: false, //货币符号是否在后面
    cluster: 'id', // 所属集群
    fds_cluster: 'id', // fds 所属集群
    trackId: '1360', // 埋点id
    cookieIsOpen: false, // 是否打开cookie弹框
    supportWallet: true, // 是否支持开发「钱包 &&会员」模块功能
    routeFix: '/id', //路由中不同国家的前缀
    supportKCard: true, // 是否支持K-Card
    apm_cluster: 'id', // apm所属集群
    // 切换的语言信息
    region_lang_map: {
      value: 'Indonesia',
      icon: 'flag_id.png',
      langs: ['in'],
      children: {
        in: { value: 'Bahasa Indonesia' },
      },
    },
  },
  ru: {
    zh_name: '俄罗斯',
    lang: 'ru-RU',
    i18n: 'ru_RU',
    default: false,
    thous_separator: ' ',
    decimal_point_separator: ',',
    decimalPlaces: 2,
    symbolInAfter: true,
    cluster: 'ru',
    fds_cluster: 'ru',
    trackId: '1643',
    cookieIsOpen: false,
    supportWallet: true,
    routeFix: '/ru',
    apm_cluster: 'ru',
    region_lang_map: {
      value: 'Россия(Russia)',
      icon: 'flag_ru.png',
      langs: ['ru'],
      children: {
        ru: { value: 'Pусский' },
      },
    },
  },
}

// 默认语言
export const getDefaultLang = () => 'en-US'
export const getI18nDefaultLang = () => 'en_US'
export const getAllLanguages = () => {
  return Object.keys(countryConfigs)
    .map((item) => countryConfigs[item].i18n)
    .concat(getI18nDefaultLang())
}
// 获取默认国家
export const getDefaultCountry = () => {
  return Object.keys(countryConfigs).filter(
    (item) => countryConfigs[item].default
  )[0]
}
// 所有国家列表
export const countrysList = () => {
  return Object.keys(countryConfigs) || []
}

function handlerFn(key) {
  const res = {}
  Object.keys(countryConfigs).forEach((item) => {
    res[item] = countryConfigs[item][key]
  })
  return res
}

// 国家-集群关系
export const countryOfCluster = () => {
  return handlerFn('cluster')
}
// 所有语言列表
export const langsList = () => {
  return Object.keys(countryConfigs).reduce((accumulator, curr) => {
    const lang = countryConfigs[curr].lang
    if (Array.isArray(lang)) {
      return accumulator.concat(lang)
    } else if (typeof lang === 'string') {
      accumulator.push(lang)
    }
    return accumulator
  }, [])
}

// 国家-头部切换国家对象关系
export const countryRegionLangMap = () => {
  const res = handlerFn('region_lang_map')
  const countrys = {}
  for (let k in res) {
    if (res[k] && Object.keys(res[k]).length) {
      countrys[k.toUpperCase()] = res[k]
    }
  }
  return countrys
}
// 国家-countryRegionLangMap 对应的lang
export const countryLangNameMap = () => {
  const res = handlerFn('region_lang_map')
  const langs = {}
  for (let k in res) {
    const c = res[k] && res[k].children ? res[k].children : null
    if (c) {
      for (let j in c) {
        langs[j] = c[j].value
      }
    }
  }
  return langs
}

// 国家-语言关系
export const countryOfLang = () => {
  return handlerFn('lang')
}
// 国家-千位分隔符关系
export const countryOfThousSeparator = () => {
  return handlerFn('thous_separator')
}
// 国家-小数分隔符关系
export const countryOfDecimalPointSeparator = () => {
  return handlerFn('decimal_point_separator')
}
// 国家-小数位数关系
export const countryOfDecimalPlaces = () => {
  return handlerFn('decimalPlaces')
}
// 国家-货币符号是否在后面
export const countryOfSymbolInAfter = () => {
  return handlerFn('symbolInAfter')
}
// 国家-fds集群关系
export const countryOfFdsCluster = () => {
  return handlerFn('fds_cluster')
}
// 默认fds集群
export const getDefaultFdsCluster = () => {
  return 'sgp'
}
// 国家-埋点id关系
export const countryOfTrackid = () => {
  return handlerFn('trackId')
}
// 国家-cookie弹框关系
export const countryOfCookiePopupStatus = () => {
  return Object.keys(countryConfigs).map((item) => {
    return {
      isOpen: countryConfigs[item].cookieIsOpen,
      name: item,
    }
  })
}
// 国家-支持钱包
export const countryOfSupportWallet = () => {
  return Object.keys(countryConfigs).filter(
    (item) => countryConfigs[item].supportWallet
  )
}
// 国家-路由前缀
export const routeFixList = () => {
  return Object.keys(countryConfigs).map(
    (item) => countryConfigs[item].routeFix
  )
}

// 国家-支持K-Card
export const countryOfSupportKCard = () => {
  return Object.keys(countryConfigs).filter(
    (item) => countryConfigs[item].supportKCard
  )
}

// apm 集群
export const getApmCluster = (region) => {
  return countryConfigs[region].apm_cluster
}
